import JsonApiRecordDecorator from './JsonApiRecordDecorator';

export default class JsonApiDataDecorator {
  constructor(data, store) {
    this.data = data;
    this.store = store;
    this.type = data[0].type;  //pretty sure redux-json-api will always give back an array
  }

  find(id, includes) {
    let obj = this.data.find((obj) => obj.id === id);
    if (obj) {
      return this.fillObject(obj, includes);
    }
  }

  where(predicate, includes) {
    const objs = this.data.filter(obj => predicate(Object.assign({}, obj, obj.attributes)));
    return objs.map((obj) => this.fillObject(obj, includes));
  }

  whereNonIncluded(predicate, includes) {
    const objs = this.data.filter(obj => predicate(Object.assign({}, obj, obj.attributes)));
    const nonIncludedObjs = objs.filter(obj => !obj.meta || !obj.meta.included);
    
    return nonIncludedObjs.map((obj) => this.fillObject(obj, includes));
  }

  all(includes) {
    return this.data.map(obj => this.fillObject(obj, includes));
  }

  allNonIncluded(includes) {
    return this.data
      .filter(obj => !obj.meta || !obj.meta.included)
      .map(obj => this.fillObject(obj, includes));
  }

  first(includes) {
    return this.at(0, includes);
  }

  at(index, includes) {
    return this.fillObject(this.data[index], includes);
  }

  last(includes) {
    return this.fillObject(this.data[this.data.length - 1], includes);
  }

  fillObject(original, includes) {
    let obj = Object.assign(new JsonApiRecordDecorator(), original, original.attributes);
    obj._original = original;
    delete obj.attributes;
    delete obj.meta;

    if (includes) {
      obj = this.fillRelated(obj, includes);
    }
    return obj;
  }

  fillRelated(obj, includes) {
    if (!includes) return obj;
    let relations;
    if (includes instanceof Array){
      relations = includes
    } else if (typeof includes === 'string'){
      relations = includes.split(',');
    } else {
      relations = Object.keys(includes);
    }
    relations.forEach((relation) => {
      if (obj.relationships && obj.relationships[relation]) {
        if (obj.relationships[relation].data instanceof Array) {
          obj[relation] = obj.relationships[relation].data.reduce((arr, rel) => {
            if (this.store[rel.type]) {
              let data = this.store[rel.type].find(rel.id, includes[relation]);
              if (data) {
                arr.push(data);
              }
            }
            return arr;
          }, []);
        } else {
          let rel = obj.relationships[relation].data;
          if (rel && this.store[rel.type]) {
            obj[relation] = this.store[rel.type].find(rel.id, includes[relation]);
          }
        }
      }
    });

    delete obj.relationships;
    return obj;
  }
}